<div class="row justify-content-end" *appFeaturesAuth="{section:'BUTTON',identifier:this.identifier}">
  <button class="btn btn-primary btn-sm" [disabled]="!sameOwner" (click)="emitRecoverProcessEvent(true)" *ngIf="this.isAccountSelected">
    {{ this.label| translate}}
  </button>
</div>
